module.exports = __webpack_public_path__ + "img/album_box_none.c9bf08e8.png";